import type { CustomizableMetric } from 'venn-utils';

export const FPI_BLOCK_METRICS: CustomizableMetric[] = [
  {
    key: 'effectiveDuration',
    label: 'Average Effective Duration',
    dataType: 'NUMERIC',
    category: 'Fixed Income Metrics',
    metricPath: 'effectiveDuration',
  },
  {
    key: 'effectiveMaturity',
    label: 'Average Effective Maturity',
    dataType: 'NUMERIC',
    category: 'Fixed Income Metrics',
    metricPath: 'effectiveMaturity',
  },
  {
    key: 'effectiveCreditQuality',
    label: 'Average Effective Credit Quality',
    dataType: 'TEXT',
    category: 'Fixed Income Metrics',
    metricPath: 'effectiveCreditQuality',
  },
  {
    key: 'weightedCoupon',
    label: 'Average Weighted Coupon',
    dataType: 'PERCENTAGE',
    category: 'Fixed Income Metrics',
    metricPath: 'weightedCoupon',
  },
  {
    key: 'weightedPrice',
    label: 'Average Weighted Price',
    dataType: 'PERCENTAGE',
    category: 'Fixed Income Metrics',
    metricPath: 'weightedPrice',
  },
  {
    key: 'yieldToMaturity',
    label: 'Yield to Maturity',
    dataType: 'PERCENTAGE',
    category: 'Fixed Income Metrics',
    metricPath: 'yieldToMaturity',
  },
  {
    key: 'yieldToWorst',
    label: 'Yield to Worst',
    dataType: 'PERCENTAGE',
    category: 'Fixed Income Metrics',
    metricPath: 'yieldToWorst',
  },
  {
    key: 'durationToWorst',
    label: 'Duration to Worst',
    dataType: 'NUMERIC',
    category: 'Fixed Income Metrics',
    metricPath: 'durationToWorst',
  },
  {
    key: 'convexity',
    label: 'Convexity',
    dataType: 'NUMERIC',
    category: 'Fixed Income Metrics',
    metricPath: 'convexity',
  },
  {
    key: 'peratio',
    label: 'Price/Earnings',
    dataType: 'NUMERIC',
    category: 'Equity Valuation Ratios',
    metricPath: 'peratio',
  },
  {
    key: 'pbratio',
    label: 'Price/Book',
    dataType: 'NUMERIC',
    category: 'Equity Valuation Ratios',
    metricPath: 'pbratio',
  },
  {
    key: 'psratio',
    label: 'Price/Sales',
    dataType: 'NUMERIC',
    category: 'Equity Valuation Ratios',
    metricPath: 'psratio',
  },
  {
    key: 'pcfratio',
    label: 'Price/Cash Flow',
    dataType: 'NUMERIC',
    category: 'Equity Valuation Ratios',
    metricPath: 'pcfratio',
  },
  {
    key: 'trailingDividendYield',
    label: 'Trailing Dividend Yield %',
    dataType: 'PERCENTAGE',
    category: 'Equity Yields',
    metricPath: 'trailingDividendYield',
  },
  {
    key: 'forecastedDividendYield',
    label: 'Forecasted Dividend Yield %',
    dataType: 'PERCENTAGE',
    category: 'Equity Yields',
    metricPath: 'forecastedDividendYield',
  },
  {
    key: 'earningsYield',
    label: 'Earnings Yield %',
    dataType: 'PERCENTAGE',
    category: 'Equity Yields',
    metricPath: 'earningsYield',
  },
  {
    key: 'historicalEarningsGrowth',
    label: 'Historical Earnings Growth %',
    dataType: 'PERCENTAGE',
    category: 'Equity Growth Metrics',
    metricPath: 'historicalEarningsGrowth',
  },
  {
    key: 'longTermEarningsGrowth',
    label: 'Long-Term Earnings Growth %',
    dataType: 'PERCENTAGE',
    category: 'Equity Growth Metrics',
    metricPath: 'longTermEarningsGrowth',
  },
  {
    key: 'bookValueGrowth',
    label: 'Long-Term Book Value Growth %',
    dataType: 'PERCENTAGE',
    category: 'Equity Growth Metrics',
    metricPath: 'bookValueGrowth',
  },
  {
    key: 'revenueGrowth',
    label: 'Long-Term Sales Growth %',
    dataType: 'PERCENTAGE',
    category: 'Equity Growth Metrics',
    metricPath: 'revenueGrowth',
  },
  {
    key: 'cashFlowGrowth',
    label: 'Long-Term Cash Flow Growth %',
    dataType: 'PERCENTAGE',
    category: 'Equity Growth Metrics',
    metricPath: 'cashFlowGrowth',
  },
  {
    key: 'roa',
    label: 'ROA % (1 yr)',
    dataType: 'PERCENTAGE',
    category: 'Other Equity Financial Metrics',
    metricPath: 'roa',
  },
  {
    key: 'roe',
    label: 'ROE % (1 yr)',
    dataType: 'PERCENTAGE',
    category: 'Other Equity Financial Metrics',
    metricPath: 'roe',
  },
  {
    key: 'netMargin',
    label: 'Net Margin %',
    dataType: 'PERCENTAGE',
    category: 'Other Equity Financial Metrics',
    metricPath: 'netMargin',
  },
  {
    key: 'debtToCapital',
    label: 'Debt to Capital %',
    dataType: 'PERCENTAGE',
    category: 'Other Equity Financial Metrics',
    metricPath: 'debtToCapital',
  },
  {
    key: 'dividendPayoutRatio',
    label: 'Dividend Payout Ratio',
    dataType: 'NUMERIC',
    category: 'Other Equity Financial Metrics',
    metricPath: 'dividendPayoutRatio',
  },
  {
    key: 'buybackYield',
    label: 'Buyback Yield',
    dataType: 'PERCENTAGE',
    category: 'Other Equity Financial Metrics',
    metricPath: 'buybackYield',
  },
  {
    key: 'style',
    label: 'Style',
    dataType: 'TEXT',
    category: 'Equity Styles',
    metricPath: 'style',
  },
  {
    key: 'equityCapitalization',
    label: 'Capitalization',
    dataType: 'TEXT',
    category: 'Equity Styles',
    metricPath: 'equityCapitalization',
  },
  {
    key: 'marketCapitalization',
    label: 'Market Capitalization',
    dataType: 'CURRENCY',
    category: 'Other',
    metricPath: 'marketCapitalization',
  },
  {
    key: 'expenseRatio',
    label: 'Average Expense Ratio',
    dataType: 'PERCENTAGE',
    category: 'Other',
    metricPath: 'expenseRatio',
  },
  {
    key: 'income',
    label: '12-month Projected Income',
    dataType: 'CURRENCY',
    category: 'Other',
    metricPath: 'income',
  },
];
